import { memo } from 'react';
import { UnicodeEntity } from '@mews/enums';
import { DateTimeService, LocalizedShortMonthName, useTimezone } from '@mews/framework';
import { LocalizedUtcComponentProps } from './types';

export const LocalizedUtcShortMonthYear = memo(({ utcString }: LocalizedUtcComponentProps) => {
    const timezone = useTimezone();
    const date = DateTimeService.fromUtcString(utcString, timezone);
    const year = DateTimeService.getYear(date);

    return (
        <>
            <LocalizedShortMonthName dateTime={date} />
            {UnicodeEntity.NoBreakSpace}
            {year}
        </>
    );
});
